import React from "react";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {accessConstants, authUtils} from "mindsets-js-sdk";

const Edit = function ({item_id}) {
    const me = useSelector(state => state.me);
    if (authUtils.iCan(me, [accessConstants.PERMISSION_CAN_MANAGE_ANNOUNCEMENTS])) {
        return (
            <Link to={'/announcements/' + item_id} className="button">Edit</Link>
        );
    }

    return null;
}

Edit.propTypes = {
    item_id: PropTypes.number.isRequired
}

export default Edit;
